export default {
  ['accessToken']: state => state.accessToken,
  ['isAuthenticated']: state => !!state.accessToken,
  ['fullToken']: state => state.accessToken && `Bearer ${state.accessToken}`,
}
